"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InverterMonitoringApi = exports.InverterMonitoringApiFactory = exports.InverterMonitoringApiFp = exports.InverterMonitoringApiAxiosParamCreator = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("../base");
/**
 * InverterMonitoringApi - axios parameter creator
 * @export
 */
exports.InverterMonitoringApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} powerPlantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerPlantSiteInfo: function (powerPlantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'powerPlantId' is not null or undefined
                    if (powerPlantId === null || powerPlantId === undefined) {
                        throw new base_1.RequiredError('powerPlantId', 'Required parameter powerPlantId was null or undefined when calling getPowerPlantSiteInfo.');
                    }
                    localVarPath = "/api/InverterMonitoring/PowerPlantSiteInfo/{powerPlantId}"
                        .replace("{" + "powerPlantId" + "}", encodeURIComponent(String(powerPlantId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication bearer required
                    // http bearer authentication required
                    if (configuration && configuration.accessToken) {
                        accessToken = typeof configuration.accessToken === 'function'
                            ? configuration.accessToken()
                            : configuration.accessToken;
                        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                    }
                    localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {boolean} [isComplete]
         * @param {boolean} [isSemiComplete]
         * @param {boolean} [isError]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerPlantStates: function (isComplete, isSemiComplete, isError, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/InverterMonitoring/PowerPlantStates";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication bearer required
                    // http bearer authentication required
                    if (configuration && configuration.accessToken) {
                        accessToken = typeof configuration.accessToken === 'function'
                            ? configuration.accessToken()
                            : configuration.accessToken;
                        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                    }
                    if (isComplete !== undefined) {
                        localVarQueryParameter['isComplete'] = isComplete;
                    }
                    if (isSemiComplete !== undefined) {
                        localVarQueryParameter['isSemiComplete'] = isSemiComplete;
                    }
                    if (isError !== undefined) {
                        localVarQueryParameter['isError'] = isError;
                    }
                    localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * InverterMonitoringApi - functional programming interface
 * @export
 */
exports.InverterMonitoringApiFp = function (configuration) {
    return {
        /**
         *
         * @param {number} powerPlantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerPlantSiteInfo: function (powerPlantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.InverterMonitoringApiAxiosParamCreator(configuration).getPowerPlantSiteInfo(powerPlantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {boolean} [isComplete]
         * @param {boolean} [isSemiComplete]
         * @param {boolean} [isError]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerPlantStates: function (isComplete, isSemiComplete, isError, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.InverterMonitoringApiAxiosParamCreator(configuration).getPowerPlantStates(isComplete, isSemiComplete, isError, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * InverterMonitoringApi - factory interface
 * @export
 */
exports.InverterMonitoringApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {number} powerPlantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerPlantSiteInfo: function (powerPlantId, options) {
            return exports.InverterMonitoringApiFp(configuration).getPowerPlantSiteInfo(powerPlantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {boolean} [isComplete]
         * @param {boolean} [isSemiComplete]
         * @param {boolean} [isError]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerPlantStates: function (isComplete, isSemiComplete, isError, options) {
            return exports.InverterMonitoringApiFp(configuration).getPowerPlantStates(isComplete, isSemiComplete, isError, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * InverterMonitoringApi - object-oriented interface
 * @export
 * @class InverterMonitoringApi
 * @extends {BaseAPI}
 */
var InverterMonitoringApi = /** @class */ (function (_super) {
    __extends(InverterMonitoringApi, _super);
    function InverterMonitoringApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {InverterMonitoringApiGetPowerPlantSiteInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InverterMonitoringApi
     */
    InverterMonitoringApi.prototype.getPowerPlantSiteInfo = function (requestParameters, options) {
        var _this = this;
        return exports.InverterMonitoringApiFp(this.configuration).getPowerPlantSiteInfo(requestParameters.powerPlantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {InverterMonitoringApiGetPowerPlantStatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InverterMonitoringApi
     */
    InverterMonitoringApi.prototype.getPowerPlantStates = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return exports.InverterMonitoringApiFp(this.configuration).getPowerPlantStates(requestParameters.isComplete, requestParameters.isSemiComplete, requestParameters.isError, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InverterMonitoringApi;
}(base_1.BaseAPI));
exports.InverterMonitoringApi = InverterMonitoringApi;
